/* @flow @format */

import { type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as React from 'react';
import qs from 'qs';

import type { Dispatch, StoreState } from '../redux/types';
import { fetchAgreementBegin } from '../redux/reducer/term';
import { signinBegin } from '../redux/reducer/auth';
import { toJapanTime } from '../utils';
import SplashPage from './SplashPage';
import ZkaiPage from './ZkaiPage';

const timelines = [
  {
    title: 'お皿を仕分けよう',
    text: 'お皿を仕分けて片付けます。二進数の概念に触れながら、フローチャートを使って条件分岐を含んだプログラムを設計する方法を学びます。',
  },
  {
    title: 'お会計をしよう',
    text: 'おすしの代金を計算します。段階的に手順を考え、変数や引数の概念と組み合わせてプログラムを設計する体験をします。',
  },
  {
    title: 'お皿を数えよう',
    text: 'お皿を数えて代金の計算をします。変数に値を代入する代入演算子の基本を学びながらプログラムを作成します。',
  },
  {
    title: 'あやまりを検出しよう',
    text: '意図通りに仕分けされないお皿を検出する方法を考えます。誤作動の原因に着目し、より実用的なプログラムを設計する力を育みます。',
  },
];

type State = {
  loading: boolean,
};

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {
  ...OwnProps,
  signinBegin: typeof signinBegin,
  fetchAgreementBegin: typeof fetchAgreementBegin,

  fetching: boolean,
  active: number | void,
  accepted: boolean,
};

class ZPro6 extends React.Component<Props, State> {
  state = {
    loading: true,
  };

  restoreTitle: ?Function;
  token: string;

  constructor(props: Props) {
    super(props);

    const urlParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (!urlParams.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
    }
  }

  componentDidMount() {
    const oldTitle = document.title;
    this.restoreTitle = () => {
      document.title = oldTitle;
    };
    document.title = 'Z-pro 小学6年生';
    const urlParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this.token = typeof urlParams.token === 'string' ? urlParams.token : '';
    if (!this.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
      return;
    }

    const { fetchAgreementBegin } = this.props;

    fetchAgreementBegin({
      token: this.token,
      ticketSlug: 'z-pro-6',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });

    this.setState({ loading: false });
  }

  componentWillUnmount() {
    if (this.restoreTitle) this.restoreTitle();
  }

  handleStartClick = () => {
    this.props.signinBegin({
      token: this.token,
      ticketSlug: 'z-pro-6',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });
  };

  render() {
    const { loading } = this.state;
    const { fetching, accepted, active } = this.props;

    if (loading || fetching) return <SplashPage />;
    return (
      <ZkaiPage
        kind="sushi-a"
        timelines={timelines}
        tagline="Z会小学生コース/小学生タブレットコース 6年生"
        accepted={accepted}
        active={active}
        onStartClick={this.handleStartClick}
        is6th
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch, _: OwnProps) => ({
  signinBegin: (input) => dispatch(signinBegin(input)),
  fetchAgreementBegin: (input) => dispatch(fetchAgreementBegin(input)),
});

function mapStateToProps(state: StoreState) {
  const {
    term: { privacyPolicySigned, termsOfUseSigned, timestamp },
  } = state;

  const fetching = !timestamp;
  const accepted = privacyPolicySigned && termsOfUseSigned;
  let active = undefined;
  if (!fetching) {
    const japanTime = toJapanTime(new Date(timestamp));
    // Date.getMonth() return value in [0, 11]
    const month = japanTime.getUTCMonth() + 1;
    const dayOfMonth = japanTime.getUTCDate();
    if (1 <= month && month <= 3) {
      // the switching date of course 4 is Jan 5th
      if (month === 1 && dayOfMonth < 5) active = 2;
      else active = 3;
    } else if (4 <= month && month <= 6) {
      active = 0;
    } else if (7 <= month && month <= 9) {
      active = 1;
    } else if (10 <= month && month <= 12) {
      active = 2;
    }
  }

  return { fetching, accepted, active };
}

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ZPro6);
